import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';
import { Button } from './Button';

function Navbar() {
    const [click, setClick] = useState(false);
    const [button, setButton] = useState(true);
    const [showNavbar, setShowNavbar] = useState(true);
    
    // Use useRef to persist the lastScrollY value between renders
    const lastScrollY = useRef(0);

    const handleClick = () => setClick(!click);
    const closeMobileMenu = () => setClick(false);

    const showButton = () => {
        if (window.innerWidth <= 960) {
            setButton(false);
        } else {
            setButton(true);
        }
    };

    useEffect(() => {
        showButton();
        
        const handleScroll = () => {
            if (window.scrollY > lastScrollY.current) {
                setShowNavbar(false); // Hide navbar on scroll down
            } else {
                setShowNavbar(true); // Show navbar on scroll up
            }
            lastScrollY.current = window.scrollY; // Update last scroll position
        };
        
        // Add event listener for scroll
        window.addEventListener('scroll', handleScroll);
        
        // Clean up the event listener on component unmount
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    // Move this outside useEffect to avoid adding event listener on every render
    useEffect(() => {
        window.addEventListener('resize', showButton);
        
        // Clean up resize event listener on unmount
        return () => {
            window.removeEventListener('resize', showButton);
        };
    }, []);

    return (
        <>
            <nav className={`navbar ${showNavbar ? '' : 'hidden'}`}>
                <div className="navbar-container">
                    <Link to="/" className="navbar-logo" onClick={closeMobileMenu}>
                        AURA <i className='fab fa-typo3' />
                    </Link>
                    <div className='menu-icon' onClick={handleClick}>
                        <i className={click ? 'fas fa-times' : 'fas fa-bars'} />
                    </div>
                    <ul className={click ? 'nav-menu active' : 'nav-menu'}>
                        <li className='nav-item'>
                            <Link to='/' className='nav-links' onClick={closeMobileMenu}>
                                Home
                            </Link>
                        </li>
                        {/* <li className='nav-item'>
                            <Link to='/services' className='nav-links' onClick={closeMobileMenu}>
                                Services
                            </Link>
                        </li> */}
                        {/* <li className='nav-item'>
                            <Link to='/products' className='nav-links' onClick={closeMobileMenu}>
                                Products
                            </Link>
                        </li> */}
                    </ul>
                </div>
            </nav>
        </>
    );
}

export default Navbar;